import { Controller } from "@hotwired/stimulus"

// Live search of the public FAQ (Ui::Visitor::FaqPageComponent): keeps the questions whose question or answer
// holds every typed word (accents and case ignored), hides the themes left empty and their sidebar links,
// and shows the empty state when nothing matches.
export default class extends Controller {
  static targets = ["input", "group", "empty"]

  filter () {
    const words = this.normalize(this.inputTarget.value).split(/\s+/).filter(Boolean)
    let visibleCount = 0

    this.groupTargets.forEach((group) => {
      let groupCount = 0

      group.querySelectorAll("details").forEach((details) => {
        const text = this.normalize(details.textContent)
        const visible = words.every((word) => text.includes(word))

        details.hidden = !visible
        if (visible) groupCount += 1
      })

      group.hidden = groupCount === 0
      this.linksTo(group).forEach((link) => { link.closest("li").hidden = group.hidden })
      visibleCount += groupCount
    })

    if (this.hasEmptyTarget) this.emptyTarget.hidden = visibleCount > 0
  }

  submit (event) {
    event.preventDefault()
    this.filter()
  }

  linksTo (group) {
    return Array.from(this.element.querySelectorAll("a[href^='#']"))
      .filter((link) => decodeURIComponent(link.hash.slice(1)) === group.id)
  }

  normalize (text) {
    return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()
  }
}
